import { useCopyToClipboard } from '@zeiss/lib-helpers';
import { useTranslation } from 'react-i18next';

import { showToast } from 'src/helpers/showToast';

export const useInvitationClipboard = () => {
  const { t } = useTranslation(['invitations']);
  const { copyToClipboard, textCopied } = useCopyToClipboard();

  const copyInvitationLink = (invitationUrl: string) => {
    return copyToClipboard(invitationUrl, () => {
      showToast({
        props: {
          title: t('invitations:notification.linkCopied'),
          type: 'success',
        },
      });
    });
  };

  return {
    copyInvitationLink,
    textCopied,
  };
};
